import moment from 'moment'

/*
title: [
  '姓名', '月份',
  'i1', 'i2', 'i3', '誤餐費',
  'g1', 'g2', 'g3', '績效誤餐',
  '交通加班',
]
*/

function parseRecord (record) {
  const name = record[0]

  const start = moment(`${record[1]} ${record[2]}`, 'YYYY-M-D HH:mm')
  const end = moment(`${record[1]} ${record[3]}`, 'YYYY-M-D HH:mm')
  if (start.isAfter(end)) {
    end.add(1, 'day')
  }

  const tStart = moment(`${record[1]} ${record[4]}`, 'YYYY-M-D HH:mm')
  const tEnd = moment(`${record[1]} ${record[5]}`, 'YYYY-M-D HH:mm')
  if (tStart.isAfter(tEnd)) {
    tEnd.add(1, 'day')
  }

  return { name, start, end, tStart, tEnd }
}

function toDateType (isWorking) {
  if (isWorking === false) return 'holiday'
  if (isWorking === 'false') return 'holiday'
  if (isWorking === true) return 'workday'
  if (isWorking === 'true') return 'workday'

  return isWorking
}
function parseSpecialDate (d) {
  const { name, date, isWorking } = d

  return {
    name,
    date: moment(date, 'YYYY-M-D'),
    type: toDateType(isWorking),
  }
}

function makeGetDateType (specialDates) {
  const dictionary = { }
  specialDates.forEach((d) => (dictionary[d.date.format('YYYYMMDD')] = d.type))

  return function getDateType (date) {
    const key = date.format('YYYYMMDD')
    if (dictionary[key] !== undefined) return dictionary[key]

    const weekDay = date.day()
    if (weekDay === 6) return 'dayoff'
    if (weekDay === 0) return 'leave'

    return 'workday'
  }
}

function groupByDate (records) {
  const dateGroups = { }
  records.forEach((record) => {
    const key = record.start.format('YYYYMMDD')
    dateGroups[key] = dateGroups[key] || []
    dateGroups[key].push(record)
  })
  return dateGroups
}
function groupByNameAndDate (records) {
  const nameGroups = { }
  records.forEach((record) => {
    nameGroups[record.name] = nameGroups[record.name] || { records: [] }
    nameGroups[record.name].records.push(record)
  })

  const nameDateGroups = { }
  Object.keys(nameGroups).forEach((name) => {
    nameDateGroups[name] = groupByDate(nameGroups[name].records)
  })

  return nameDateGroups
}

function sumAndRoundHours (records, roundUpFunc = h => h) {
  const hours = records.reduce((total, { start, end }) => (
    total + end.diff(start, 'hours', true)
  ), 0)

  const roundedHours = roundUpFunc(hours)

  return {
    hours,
    roundedHours,
    roundUp: (roundedHours > hours) ? roundedHours : null,
  }
}

const emptyOverTime = { o33: 0, o43: 0, o53: 0, o63: 0, o83: 0 }
const emptyPerformance = { p33: 0, p43: 0, p53: 0, p63: 0, p83: 0 }
function calcWorkday (records) {
  const { hours, roundedHours } = sumAndRoundHours(records)

  const o43 = Math.min(2, hours)
  const o53 = Math.max(Math.min(4, hours) - 2, 0)
  const p53 = Math.max(Math.min(24, hours) - 4, 0)

  return {
    hours,
    roundedHours,
    overtime: { ...emptyOverTime, o43, o53 },
    performance: { ...emptyPerformance, p53 },
  }
}

function roundDayoffHours (hours) {
  // if (hours <= 4) return 4
  // if (hours <= 8) return 8
  // if (hours <= 12) return 12
  return hours
}
function calcDayoff (records) {
  const { hours, roundedHours } = sumAndRoundHours(records, roundDayoffHours)

  const o43 = Math.min(2, roundedHours)
  const o53 = Math.max(Math.min(8, roundedHours) - 2, 0)
  const o83 = Math.max(Math.min(12, roundedHours) - 8, 0)
  const p83 = Math.max(Math.min(24, roundedHours) - 12, 0)

  return {
    hours,
    roundedHours,
    overtime: { ...emptyOverTime, o43, o53, o83 },
    performance: { ...emptyPerformance, p83 },
  }
}

function roundLeaveHours (hours) {
  // if (hours <= 8) return 8
  return hours
}
function calcLeave (records) {
  const { hours, roundedHours } = sumAndRoundHours(records, roundLeaveHours)

  const p43 = Math.min(2, roundedHours)
  const p53 = Math.max(Math.min(8, roundedHours) - 2, 0)
  const p83 = Math.max(Math.min(24, roundedHours) - 8, 0)

  return {
    hours,
    roundedHours,
    overtime: { ...emptyOverTime },
    performance: { ...emptyPerformance, p43, p53, p83 },
  }

  // issue #74 change leave as dayoff
  // const o33 = Math.min(8, roundedHours)
  // const o63 = Math.max(Math.min(12, roundedHours) - 8, 0)
  // const p63 = Math.max(Math.min(24, roundedHours) - 12, 0)

  // return {
  //   hours,
  //   roundedHours,
  //   overtime: { ...emptyOverTime, o33, o63 },
  //   performance: { ...emptyPerformance, p63 },
  // }
}

function roundHolidayHours (hours) {
  // if (hours <= 8) return 8
  return hours
}
function calcHoliday (records) {
  const { hours, roundedHours } = sumAndRoundHours(records, roundHolidayHours)

  const o43 = Math.min(2, roundedHours)
  const o53 = Math.max(Math.min(8, roundedHours) - 2, 0)
  const o83 = Math.max(Math.min(12, roundedHours) - 8, 0)
  const p83 = Math.max(Math.min(24, roundedHours) - 12, 0)

  return {
    hours,
    roundedHours,
    overtime: { ...emptyOverTime, o43, o53, o83 },
    performance: { ...emptyPerformance, p83 },
  }

  // 2021/05/02 change holiday as dayoff
  // const o33 = Math.min(8, roundedHours)
  // const o43 = Math.max(Math.min(10, roundedHours) - 8, 0)
  // const o53 = Math.max(Math.min(12, roundedHours) - 10, 0)
  // const p53 = Math.max(Math.min(24, roundedHours) - 12, 0)

  // return {
  //   hours,
  //   roundedHours,
  //   overtime: { ...emptyOverTime, o33, o43, o53 },
  //   performance: { ...emptyPerformance, p53 },
  // }
}

function ifIncludeLimits (type) {
  if (type === 'leave') return false
  return true
}
const calcFuncMap = {
  workday: calcWorkday,
  dayoff: calcDayoff,
  leave: calcLeave,
  holiday: calcHoliday,
}

// AUDIT 2026-07: assumes every record carries tStart/tEnd. Records built by
// parseRecord() always have both properties, but they may be *invalid* moments
// when the source row has no traffic columns -- diff() then yields NaN, and the
// NaN propagates silently into the monthly traffic total rather than throwing.
// Worth pinning with a test before migrating; a golden master over real export
// data would catch it.
// (This is also where 13 specs in __tests__/calcOvertime-test.js crash, but
//  that is stale fixtures rather than this bug -- see the note in that file.)
function sumTrafficHours (records) {
  const hours = records.reduce((total, { tStart, tEnd }) => (
    total + tEnd.diff(tStart, 'hours', true)
  ), 0)

  return hours
}
function getNote (calcResult) {
  const { hours, roundedHours } = calcResult
  if (roundedHours > hours) return `加班 ${hours} 小時以 ${roundedHours} 小時計算`
  return ''
}
function buildOneDateData (specialDates) {
  const getDateType = makeGetDateType(specialDates)

  return (records) => {
    const { name, start } = records[0]
    const date = moment(start).startOf('date')
    const type = getDateType(date)
    const includeLimit = ifIncludeLimits(type)
    const traffic = sumTrafficHours(records)

    const calcResult = calcFuncMap[type](records)
    const note = getNote(calcResult)

    return { name, date, type, includeLimit, traffic, note, ...calcResult }
  }
}
function buildDailyData (nameDateRecords, specialDates) {
  const dataBuilder = buildOneDateData(specialDates)

  const dailyData = {}
  Object.keys(nameDateRecords).forEach((name) => {
    const dateRecords = nameDateRecords[name]
    dailyData[name] = {}
    Object.keys(dateRecords).forEach((dateKey) => {
      const records = dateRecords[dateKey]
      dailyData[name][dateKey] = dataBuilder(records)
    })
  })

  return dailyData
}

function flatDailyData (dailyData) {
  const result = []
  Object.keys(dailyData).forEach((name) => {
    Object.keys(dailyData[name]).forEach((dateKey) => {
      result.push(dailyData[name][dateKey])
    })
  })
  return result
}

function handleOverflow (volume, overflow, rest, add) {
  if (add < rest) {
    return [volume + add, overflow, rest - add]
  }
  return [volume + rest, overflow + add - rest, 0]
}
function sumOfValues (obj) {
  return Object.keys(obj).reduce((sum, key) => sum + obj[key], 0)
}
function sumWithWeights (vs, ws) {
  return vs.reduce((sum, v, i) => sum + v * ws[i], 0)
}
function accumulateDailyData (entries, start, end, startLimit) {
  let limit = startLimit
  let [o33, o43, o53, o63, o83] = [0, 0, 0, 0, 0]
  let [p33, p43, p53, p63, p83] = [0, 0, 0, 0, 0]
  let traffic = 0
  let note = ''
  const name = entries[0].name

  entries.forEach((e) => {
    if (!e.includeLimit) {
      limit += sumOfValues(e.overtime)
    }

    let rest = limit - (o33 + o43 + o53 + o63 + o83)

    ;[o33, p33, rest] = handleOverflow(o33, p33, rest, e.overtime.o33)
    ;[o43, p43, rest] = handleOverflow(o43, p43, rest, e.overtime.o43)
    ;[o53, p53, rest] = handleOverflow(o53, p53, rest, e.overtime.o53)
    ;[o63, p63, rest] = handleOverflow(o63, p63, rest, e.overtime.o63)
    ;[o83, p83, rest] = handleOverflow(o83, p83, rest, e.overtime.o83)

    p33 += e.performance.p33
    p43 += e.performance.p43
    p53 += e.performance.p53
    p63 += e.performance.p63
    p83 += e.performance.p83

    traffic += e.traffic

    if (e.note) {
      if (note) note += '，'
      note += `${e.date.format('YYYY-MM-DD')} ${e.note}`
    }
  })

  const wieghts = [3 / 3, 4 / 3, 5 / 3, 6 / 3, 8 / 3]
  const overtimeFactor = sumWithWeights([o33, o43, o53, o63, o83], wieghts)
  const performanceFactor = sumWithWeights([p33, p43, p53, p63, p83], wieghts)

  return {
    name,
    start,
    end,
    traffic,
    hours: o33 + o43 + o53 + o63 + o83 + p33 + p43 + p53 + p63 + p83,
    overtime: { o33, o43, o53, o63, o83 },
    performance: { p33, p43, p53, p63, p83 },
    factor: overtimeFactor + performanceFactor,
    overtimeFactor,
    performanceFactor,
    note,
  }
}

function buildMonthReport (dailyData, start, end) {
  const report = {}
  Object.keys(dailyData).forEach((name) => {
    const entriesObj = dailyData[name]
    const entries = Object.keys(entriesObj).map(dateKey => entriesObj[dateKey])
    report[name] = accumulateDailyData(entries, start, end, 46)
  })

  return report
}


// rs example: ['Charles', '2016-8-1', '18:00', '18:30'],
export default function calcOvertime (rs, dates, start, end) {
  const records = rs.map(parseRecord)
  const specialDates = dates.map(parseSpecialDate)

  const nameDateRecords = groupByNameAndDate(records)

  const dailyData = buildDailyData(nameDateRecords, specialDates)
  const reportData = buildMonthReport(dailyData, moment(start, 'YYYY-M-D'), moment(end, 'YYYY-M-D'))

  return {
    dailyData: flatDailyData(dailyData),
    reportData,
  }
}

export {
  parseRecord,
  toDateType,
  parseSpecialDate,
  makeGetDateType,
  groupByNameAndDate,
  calcWorkday,
  calcDayoff,
  calcLeave,
  calcHoliday,
  buildOneDateData,
  flatDailyData,
  accumulateDailyData,
}



// WEBPACK FOOTER //
// ./src/app/components/overtimeExportForm/calcOvertime.js